function appendToFormData(formData: FormData, data: any, prefix: string) {
  if (data === null || data === undefined) return
  if (Array.isArray(data)) {
    data.forEach((item, index) => appendToFormData(formData, item, `${prefix}[${index}]`))
  } else if (typeof data === 'object' && !(data instanceof File)) {
    Object.entries(data).forEach(([key, value]) => appendToFormData(formData, value, `${prefix}[${key}]`))
  } else {
    formData.append(prefix, data)
  }
}

export function convertDate(date: string): string {
  if (date && date !== '') {
    const [day, month, yearAndTime] = date.split('.')
    const year = yearAndTime?.split(' ')[0]
    const time = yearAndTime?.split(' ')[1]
    return `${year}-${month}-${day} ${time}`
  }
  return date
}

export function buildInfoFormData(data): { formData: FormData; hasFiles: boolean } {
  const formData = new FormData()
  formData.append('type', data.type)
  formData.append('name', data.name)
  if (data.from) {
    formData.append('from', convertDate(data.from.toString()))
  }
  if (data.to) {
    formData.append('to', convertDate(data.to.toString()))
  }
  (data.farmerGroups || []).forEach(id => formData.append('farmerGroups[]', id));

  [data.roles].flat().forEach(id => formData.append('roles[]', id))

  formData.append('downloadEnabled', data.downloadEnabled)
  let hasFiles = false
  data.languages.forEach(language => {
    delete language.fileEdit
    if (language.file instanceof File) {
      hasFiles = true
      formData.append(`file-${language.id}`, language.file)
      delete language.file
    } else {
      delete language.file
    }
  })
  appendToFormData(formData, data.languages, 'languages')
  return { formData, hasFiles }
}

export function buildDataPayload(data) {
  return {
    ...data,
    from: data.from ? convertDate(data.from.toString()) : data.from,
    to: data.to ? convertDate(data.to.toString()) : data.to,
    roles: [data.roles]
  }
}
